import { parseBRLCurrencyToNumber } from "@/analytics/format";
import type { CotacaoEcommerce } from "@/types/Cotacao";

export type PaymentKind = "pix" | "credit" | "bank" | undefined;

function toNum(v?: string | null): number {
  if (v == null) return 0;

  const br = parseBRLCurrencyToNumber(v);
  if (Number.isFinite(br) && br !== 0) return br;
  const n = parseFloat(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}

export function computeQuoteTotals(
  c: CotacaoEcommerce,
  typePayment?: PaymentKind
) {
  const base = toNum(c.cve_preco_cotacao);
  const seguro_base = toNum(c.cve_valor_seguro);
  const seguro_plus = toNum(c.cve_valor_seguro);
  const coleta = toNum(c.cve_valor_coleta);
  const entrega = toNum(c.cve_valor_entrega);
  const acrescimo = toNum(c.cve_valor_acrescimo);
  const acrescimo_veiculo = toNum(c.cve_valor_acrescimo_veiculo);
  const upsell = toNum(c.cve_valor_upsell);

  let additionals = acrescimo + acrescimo_veiculo + upsell;
  if (c.cve_tipo_seguro === "2") additionals += seguro_plus;
  if (c.cve_tipo_seguro === "0") additionals += seguro_base;
  if (c.tro_codigo === "2") additionals += coleta;
  if (c.trd_codigo === "2") additionals += entrega;

  const subtotal = base + additionals;

  const descontoCotacao = toNum(c.cve_valor_desconto);
  const valorCupom = toNum(c.cup_valor);

  let descontoCupom = 0;
  if (c.cup_valor_tipo === "PERCENTUAL") {
    descontoCupom = (base * valorCupom) / 100;
  } else if (c.cup_valor_tipo === "FIXO") {
    descontoCupom = valorCupom;
  }

  let descontoPIX = 0;
  if (typePayment === "pix") {
    descontoPIX = (base * 5) / 100;
  }

  const bestCouponOrPix = Math.max(descontoCupom, descontoPIX);
  const discount =
    (isNaN(descontoCotacao) ? 0 : descontoCotacao) +
    (isNaN(bestCouponOrPix) ? 0 : bestCouponOrPix);

  const total = subtotal - discount;

  return {
    base,
    additionals,
    subtotal,
    discount,
    total,
    // infos do cupom
    coupon: c.cup_nome || undefined,
    coupon_code: c.cup_codigo || undefined,
    coupon_type: c.cup_valor_tipo || undefined, // 'PERCENTUAL' | 'FIXO' | ''
    coupon_value: valorCupom || undefined,
    // breakdown de descontos
    discount_breakdown: {
      platform_discount: isNaN(descontoCotacao) ? 0 : descontoCotacao,
      coupon_or_pix: isNaN(bestCouponOrPix) ? 0 : bestCouponOrPix,
      used:
        bestCouponOrPix === 0
          ? "none"
          : bestCouponOrPix === descontoPIX
          ? "pix"
          : "coupon",
    },
  };
}
